import styled from 'styled-components';

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 0.5rem;
  padding: 0.5rem;
`;

export default PageContainer;
